import { inputStyle } from "../shared";

export const readOnlyStyle = {
  ...inputStyle,
  background: "#F5F1EA",
  color: "#2B2B2B",
  cursor: "default",
  userSelect: "text",
};

// ── Team add-on config ─────────────────────────────────────────────────────
export const ADDON_PLANS = [
  { id: "starter",   label: "Team Starter",   price: "$6/mo",  limit: 2,         priceId: "price_1TeqJiHgweDWY7O1eNJF0oDV" },
  { id: "plus",      label: "Team Plus",      price: "$12/mo", limit: 5,         priceId: "price_1TeqK4HgweDWY7O1FWNitDcw" },
  { id: "unlimited", label: "Team Unlimited", price: "$20/mo", limit: Infinity,  priceId: "price_1TeqKVHgweDWY7O1iR8MckuA" },
];
export const ADDON_LIMIT = { none: 0, starter: 2, plus: 5, unlimited: Infinity };

export const PERMISSION_OPTIONS = [
  { value: "view_only",   label: "View Only",    desc: "Read-only — can view tenants and maintenance, cannot edit anything." },
  { value: "payments",    label: "Payments",     desc: "Can record and edit payments. Cannot access settings or delete records." },
  { value: "maintenance", label: "Maintenance",  desc: "Can update maintenance tickets and add notes." },
  { value: "tenants",     label: "Tenants",      desc: "Can add and edit tenant records." },
  { value: "full_access", label: "Full Access",  desc: "Everything except billing and team management." },
];

export const ROLE_COLOR  = { admin: "#163C2F", manager: "#B08D57", employee: "#9B9690", view_only: "#9B9690" };
export const ROLE_LABEL  = { admin: "Admin", manager: "Manager", employee: "Employee", view_only: "View Only" };
export const ROLE_DESC   = {
  admin:     "Full access — settings, billing, delete, team management",
  manager:   "View &amp; edit tenants, payments, maintenance; no settings or delete",
  view_only: "Read-only — can view tenants and maintenance, cannot edit anything",
};

export const PLAN_LABEL  = { free: "Free",  core: "Core",  starter: "Core", pro: "Pro",  owner: "Owner ✦" };
export const PLAN_COLOR  = { free: "#9B9690", core: "#163C2F", starter: "#163C2F", pro: "#7FB98E", owner: "#163C2F" };
export const PLAN_DESC   = {
  free:    "Basic access — unlimited properties & tenants with essential features.",
  core:    "Full maintenance tracking, email notifications, document center, and more.",
  starter: "Full maintenance tracking, email notifications, document center, and more.",
  pro:     "Everything in Core plus advanced reports and team access.",
  owner:   "Unlimited Pro access.",
};
